export default "__VITE_ASSET__0Tj70hfK__"